<template>
    <div
        :class="[
            'form-group',
            'form-select',
            size,
            disactive == true ? 'd-none' : '',
        ]"
    >
        <label class="form-select__label" :for="name">{{ label }}</label>
        <div class="form-select__custom-select">
            <span class="form-select__label-icon material-symbols-outlined">
                {{ icon }}
            </span>
            <select
                :class="
                    'form-select__select custom-select form-control ' +
                    (errors !== null ? 'error-input' : '')
                "
                :name="name"
                :value="modelValue"
                :placeholder="placeholder"
                @input="updateValue($event.target.value)"
                maxlength="150"
            >
                <option disabled selected value>Wybierz...</option>
                <option
                    v-for="(val, index) in values"
                    :value="index"
                    v-html="val"
                    v-bind:selected="index == value"
                    :key="val"
                ></option>
            </select>
            <span class="form-select__triangle"></span>
            <span class="form-select__select-wrapper-border"></span>
        </div>
        <div class="error" v-if="errors">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
        <small
            class="form-text text-muted"
            v-if="extraInfo"
            v-html="extraInfo"
        ></small>
    </div>
</template>

<script>
export default {
    props: [
        "label",
        "values",
        "name",
        "placeholder",
        "size",
        "disactive",
        "errorMessages",
        "extraInfo",
        "modelValue",
        "icon",
    ],

    methods: {
        updateValue(value) {
            this.$emit("input", value);
            console.log(`emitted value: `, value);
            if (this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
    },
    data() {
        return {
            value: "",
        };
    },
    computed: {
        errors: function () {
            if (
                this.errorMessages &&
                this.name in this.errorMessages &&
                this.value === ""
            ) {
                return this.errorMessages[this.name];
            }

            return null;
        },
    },
    watch: {
        errorMessages: function (newValue, oldValue) {
            this.value = "";
        },
    },
};
</script>
